import React from "react";
import {getOptionName} from "../../utils/selectbox/selectorUtils";

function SelectorOptionLabel({option}) {
    const name = getOptionName(option);

    return (
        <span className="selector-option-name">
            {option?.color ? (
                <span
                    className="selector-option-swatch"
                    style={{backgroundColor: option.color}}
                    aria-hidden
                />
            ) : null}
            {name}
        </span>
    );
}

export default SelectorOptionLabel;
